import { Routes } from '@angular/router';
import { helperGuard, adminGuard, serviceGuard } from './core/auth.guards';

export const routes: Routes = [
  { path: 'login', loadComponent: () =>
      import('./features/login/login.component').then(m => m.LoginComponent) },
  { path: 'dev', data: { devLogin: true }, loadComponent: () =>
      import('./features/login/login.component').then(m => m.LoginComponent) },
  { path: 'forgot-password', loadComponent: () =>
      import('./features/login/forgot-password.component').then(m => m.ForgotPasswordComponent) },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () =>
      import('./features/admin/admin-shell.component').then(m => m.AdminShellComponent),
    loadChildren: () =>
      import('./features/admin/admin.routes').then(m => m.adminRoutes),
  },
  {
    path: 'service',
    canActivate: [serviceGuard],
    loadComponent: () =>
      import('./features/service/service-shell.component').then(m => m.ServiceShellComponent),
    loadChildren: () =>
      import('./features/service/service.routes').then(m => m.serviceRoutes),
  },
  {
    path: 'helper',
    canActivate: [helperGuard],
    loadComponent: () =>
      import('./features/helper/helper-shell.component').then(m => m.HelperShellComponent),
    loadChildren: () =>
      import('./features/helper/helper.routes').then(m => m.helperRoutes),
  },
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: '**', redirectTo: 'login' },
];
